(() => {
  if (customElements.get("logos-inline-slider")) return;

  class LogosInlineSlider extends HTMLElement {
    constructor() {
      super();

      this.initSwiper = this.initSwiper.bind(this);
      this.syncAutoplay = this.syncAutoplay.bind(this);
    }

    connectedCallback() {
      if (window.Swiper) {
        this.initSwiper();
      } else {
        document.addEventListener("DOMContentLoaded", this.initSwiper, { once: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener("DOMContentLoaded", this.initSwiper);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    initSwiper() {
      if (!window.Swiper || this.swiper) return;

      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.autoplayEnabled = this.hasAttribute("data-autoplay") && !reducedMotion;

      this.swiper = new Swiper(this, {
        slidesPerView: "auto",
        spaceBetween: 30,
        rewind: true,
        watchOverflow: true,
        autoplay: this.autoplayEnabled ? { delay: 2500, disableOnInteraction: false } : false,
        breakpoints: {
          769: { spaceBetween: 40 },
        },
        on: {
          lock: this.syncAutoplay,
          unlock: this.syncAutoplay,
        },
      });
      this.syncAutoplay();
    }

    syncAutoplay() {
      if (!this.swiper?.autoplay || !this.autoplayEnabled) return;

      if (this.swiper.isLocked) {
        this.swiper.autoplay.stop();
      } else {
        this.swiper.autoplay.start();
      }
    }
  }

  customElements.define("logos-inline-slider", LogosInlineSlider);
})();
